module.exports = __webpack_public_path__ + "img/btn-account-balance-en.f974a499.png";